<template>
  <div class="KeyBoardInput">
    <div class="KeyBoardInput_mask" v-show="!keyboard" @click="k_readonly?'':blurFocus()"></div>
    <div class="KeyBoardInput_box" @click.stop="k_readonly?'':focus()">
      <slot name="input_left" class="input_left"></slot>
      <div class="input_box">
        <input type="text" readonly :value="input_show_value" :placeholder="placeholder" />
        <!-- 光标 -->
        <p class="cursor" :style="{visibility: cursor ? 'visible' : 'hidden'}"></p>
      </div>
      <slot name="input_right" class="input_right"></slot>
      <!-- 键盘插件 -->
      <div class="key_board_box" v-if="keyboard">
        <!-- <div class="fake_confim" >
          <button type="button" class="van-key van-key--large" @click="blur">完成</button>
        </div> -->
        <van-number-keyboard
          v-model="keyValue"
          :show="keyboard"
          :transition="false"
          :extra-key="['AC','.']"
          :hide-on-click-outside="true"
          close-button-text="完成"
          theme="custom"
          @close="blur"
          @input="typing"
          @delete="del"
        ></van-number-keyboard>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 参数:
 *  1. v-model: 绑定值
 *  2. k_default_show: 是否默认显示键盘, 可选值 true,false  默认: false
 *  2. k_default_div: 是否有默认占位, 可选值 true,false  默认: false
 *  3. k_decimal: 保留小数位数,Number型   默认: 2
 *  4. k_placeholder: 提示语
 *  5. k_isValueZero: 是否支持值为0, 可选值 true,false  默认: true
 *  5. k_isNegative: 是否支持负数, 可选值 true,false  默认: false
 *  6. k_readonly: 是否只读, 可选值 true,false  默认: true
 *  6. @blur(value): 输入框失焦事件, 回调参数 为绑定值
 *  6. @input(value): 输入框输入事件, 回调参数 为绑定值
 */
export default {
  name: "KeyBoardInput",
  model: {
    prop: "k_value",
    event: "setValue"
  },
  props: {
    k_value: "",
    k_default_show: {
      type: Boolean,
      default: false
    },
    k_default_div: {
      type: Boolean,
      default: false
    },
    k_decimal: {
      type: Number,
      default: 2
    },
    k_placeholder: {
      type: [String, Number],
      default: ""
    },
    k_isValueZero: {
      type: Boolean,
      default: true
    },
    k_isNegative: {
      type: Boolean,
      default: false
    },
    k_appendToId: {
      type: String,
      default: "body"
    },
    k_readonly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    k_value: {
      handler(newValue, oldValue){ 
        this.value = newValue+''
        this.notify();
      },
      deep:true
    },
    k_default_show: {
      handler(newValue, oldValue){ 
        this.keyboard = newValue
        if(this.keyboard){
          this.blurFocus()
        }
      },
      deep:true
    },
    k_placeholder: {
      handler(newValue, oldValue){ 
        this.placeholder = newValue
      },
      deep:true
    },
  },
  data() {
    return {
      // prop 里的值
      value: this.k_value + "", // 用来存 输入后 的老值
      input_show_value :this.k_value + "",
      keyboard: this.k_default_show,
      placeholder: this.k_placeholder,
      decimal: this.k_decimal,
      isValueZero: this.k_isValueZero,

      // 页面的变量
      cursor: false,
      keyValue: "",
      real_val: this.k_value,
      // 非法值
      aIllegal: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "0..",
        "."
      ]
    };
  },
  created() {
    document.addEventListener("touchstart", e => {
      this.blur();
    });
    if (this.keyboard) {
      this.focus();
    }
  },
  mounted() {
  },
  methods: {
    // 对 touchstart 阻止触摸穿透
    handleShow(){
      var btnlist=document.getElementsByClassName("van-key");
      for(var i=0;i<btnlist.length;i++){
          btnlist[i].addEventListener("touchstart", e => {
            e.preventDefault()
          })
      }
    },
    blurFocus() {
      this.blur();
      setTimeout(() => {
        this.focus();
      }, 5);
    },
    /*focus*/
    focus() {
      /*显示键盘*/
      this.showKeyboard();
      /*显示光标*/
      this.showCursor();
      this.$nextTick(()=>{
        this.handleShow()
      })
    },
    /*blur*/
    blur() {
      /*隐藏光标*/
      this.hideCursor();
      /*隐藏键盘*/
      this.hideKeyboard();
      /*
        附加 00, 如果用户输入了一个以 . 结尾的值就点完成了, 
        那么这个时候就在后面加上00
      */
      this.toCompletion();
      /*通知父组件, 老子值出来了*/
      /*
        校验用户输入的金额是不是为 0, 如果是的话, 直接重置
      */
      if (!this.isValueZero) {
        this.checkValue();
      }
      this.$emit("blur", this.value); // 将当前对象 evt 传递到父组件
      this.notify();
    },
    /** 显示键盘 */
    showKeyboard() {
      this.keyboard = true;
      if(!this.k_default_div){
        this.$nextTick(() => {
          if (!document.getElementById("place_div")) {
            var height = 0
            for (let i = 0; i < document.getElementsByClassName("van-number-keyboard").length; i++) {
              const element = document.getElementsByClassName("van-number-keyboard")[i];
              if(element.offsetHeight != 0){
                height = element.offsetHeight
              }
            }
            var place_div = document.createElement("div");
            place_div.id = "place_div";
            place_div.style.height = height + "px";
            if (document.getElementById(this.k_appendToId)) {
              document.getElementById(this.k_appendToId).appendChild(place_div);
            } else {
              document.body.appendChild(place_div);
            }
            this.$el.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
          }
        });
      }
    },
    /** 隐藏键盘 */
    hideKeyboard() {
      this.keyboard = false;
      if(!this.k_default_div){
        this.$nextTick(() => {
          var place_div = document.getElementById("place_div");
          if (place_div) {
            place_div.remove();
          }
        });
      }
    },
    /** 显示光标 */
    showCursor() {
      this.cursor = true;
    },
    /** 隐藏光标 */
    hideCursor() {
      this.cursor = false;
    },
    /*
      校验用户输入的金额是不是为 0, 如果是的话, 直接重置
    */
    checkValue() {
      if (parseFloat(this.value) === 0) {
        this.value = "";
      }
    },
    /*判读是否需要加0*/
    toCompletion() {
      let list = String(this.value).split(".");
      if (list[1] === "") {
        this.value = list[0];
      } else {
        if (typeof list[1] === "undefined") {
          // if (this.value !== "") {
          //   this.value = this.value + ".";
          //   this.completion(this.decimal);
          // }
        } else {
          if (list[1].length < this.decimal) {
            this.completion(this.decimal - list[1].length);
          }
        }
      }
    },
    // 加0
    completion(len) {
      let v = "";
      for (let i = 0; i < len; i++) {
        v = v + "0";
      }
      this.value = this.value + v;
    },
    // 通知父级
    notify() {
      this.real_val = this.value;
      if(this.k_isNegative&&this.real_val&&this.real_val>0){
        this.input_show_value = '-' +this.real_val
      }else{
        this.input_show_value = this.real_val
      }
      this.$emit("setValue", this.real_val);
      this.$emit("input", this.real_val); // 将当前对象 evt 传递到父组件
    },
    // 删除按钮
    del() {
      /*删除值并不会触发值的校验, 所以需要手动再触发一次*/
      this.value = this.value.slice(0, -1);
      new Audio('http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=清除').play();
      this.notify();
    },
    /*输入*/
    typing(value) {
      let audio =''
      if(value == "AC"){
        audio = '归零'
      }else if(value == '.'){
        audio = '点'
      }else{
        audio = value
      }
      new Audio('http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex='+audio).play();
      let add_val = value; // 把value的赋值变量上 value 作为判断的值
      let old_val = this.value; // 旧的值
      // console.log(value,old_val)
      // 如果输入了AC 把旧的值 变为 0
      if (value == "AC") {
        old_val = "";
        add_val = "0";
      }
      if (old_val === "0" && add_val !== ".") {
        old_val = "";
      }
      /*获取新的值*/
      this.value = old_val + add_val;
      /*检验新值, 如果没有通过检测, 恢复值*/
      if (!this.passCheck(this.value)) {
        this.value = old_val;
        return;
      }
      // if( value == "AC"){
      //   this.value = "0"
      // }
      /*为了让外界同步输入, 需要发送事件*/
      this.notify();
    },
    passCheck(val) {
      /*验证规则*/
      let aRules = [this.illegalInput, this.illegalValue, this.accuracy];
      return aRules.every(item => {
        return item(val);
      });
    },
    /*非法输入*/
    illegalInput(val) {
      if (this.aIllegal.indexOf(val) > -1) {
        return false;
      }
      return true;
    },
    /*非法值*/
    illegalValue(val) {
      if (parseFloat(val) != val) {
        return false;
      }
      return true;
    },
    /*验证精度*/
    accuracy(val) {
      let v = val.split(".");
      if (v[0].length > this.inter) {
        return false;
      }
      if (v[1] && v[1].length > this.decimal) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.KeyBoardInput {
  width: 100%;
  position: relative;
  .KeyBoardInput_mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .KeyBoardInput_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 0.88rem;
    box-sizing: border-box;
    border-radius: 0.1rem;
    .input_right,
    .input_left {
      flex-grow: 0;
    }
    .input_box {
      width: 1rem;
      flex: auto;
      line-height: 0.8rem;
      position: relative;
      padding-right: 0.2rem;
      display: flex;
      background-color: transparent;
      text-align: right;
      .cursor {
        display: inline-block;
        width: 0.03rem;
        height: 0.32rem;
        background-color: #31b158;
        position: absolute;
        right: 0.14rem;
        top: 50%;
        transform: translateY(-50%);
        animation: inputFocus 0.8s linear infinite;
        @keyframes inputFocus {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
      input {
        width: 100%;
        text-align: right;
        font-weight: bold;
        font-size: 0.4rem;
        background-color: transparent;
      }
    }
    
    .fake_div{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 8;
      .fake_confim{
        position: absolute;
        right: 6px;
        z-index: 999;
        bottom: 6px;
        width: calc((100% - 6px)/4 - 6px);
        height: calc(50% - 12px);
        background-color: #31b158;
        border-radius: 8px;
        button{
          background-color: #31b158;
          color: #fff;
          font-size: 0.42rem;
        }
      }
    }
  }
}
</style>

<style lang="less">
.van-number-keyboard__sidebar {
  .van-key--large.van-key--blue {
    background-color: #31b158;
  }
}
</style>